module.exports = __webpack_public_path__ + "img/gold-gift-box.8a235c4f.png";